import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { getDescription } from '../../util';
import { Score } from '@tech-insights/workflows-sdk';
import { CircularProgressScore } from '../CircularProgressScore';

export type TotalScoreDisplayProps = {
  score: Score;
};

export const TotalScoreDisplay = ({
  score,
}: Readonly<TotalScoreDisplayProps>) => {
  const description = getDescription(score.achievementPercentage ?? 0);

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        margin: '0 0 0 18px',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <CircularProgressScore score={score.achievementPercentage ?? 0} />
      </Box>
      <Box sx={{ margin: '8px 16px 0 24px' }}>
        <Typography variant="h3">{description.title}</Typography>
        <Typography
          variant="body2"
          sx={{
            textAlign: 'justify',
          }}
        >
          {description.detail}
        </Typography>
      </Box>
    </Box>
  );
};
